import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LoopIcon } from '../../icons/loop';
import { Tooltip } from '../tooltip/tooltip';

import styles from './loop-button.module.css';

type Props = {
  className?: string;
  isLooping?: boolean;
  onClick?: () => void;
};

export function LoopButton({ isLooping, onClick, className }: Props) {
  const { t } = useTranslation();

  const label = isLooping ? t('ui.loop.button.label.active') : t('ui.loop.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="loop-button"
        className={classNames(className, styles.button, { [styles.active]: isLooping })}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <LoopIcon />
      </button>
    ),
    [className, isLooping, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
